<template>
  <div class="recommend-records">
    <template v-if="records.length">
      <div class="recommend-content">
        <div
          v-for="record in records"
          :key="record.ID"
          class="records-container">
          <records-card :record="record" />
        </div>
      </div>
      <div class="records-button" @click="handleAllRecords">
        <span>{{ $t('FoodD_optimization_KHwe_UDpu'/** 所有记录 */) }}</span>
        <i class="icon-v3_outlined_entrance icon"/>
      </div>
    </template>
    <template v-else>
      <div class="recommend-no-records">
        <img :src="require('@/assets/images/xtd/no-history.png')" class="recommend-pic" />
        <div class="recommend-no-history">{{ $t('FoodD_optimization_Qqcn_TvQv'/** 无邀请记录 */) }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import RecordsCard from './recordsCard'
export default {
  name: 'RecommendRecords',
  components: {
    RecordsCard
  },
  props: {
    records: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    handleAllRecords () {
      this.$router.push({
        path: `/d/rewardlist`
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
.recommend-records {
  padding: 56px 40px 40px;
  background: #fff;
  border-radius: 32px;
  .recommend-content {
    :not(:last-child)  {
      div {
        border-bottom: 1px solid rgba(97,97,97, .2);
        margin-bottom: 48px;
      }
    }
  }

  .records-button {
    font-family: DiDiSans-Pro-Medium;
    font-size: 28px;
    color: #000;
    letter-spacing: 0;
    line-height: 28px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;

    .icon {
      font-size: 18px;
      margin-left: 4px;
      margin-top: 2px;
      font-weight: 800;
      color: #000;
    }
  }
}
.recommend-no-records {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 0 52px;

  .recommend-pic {
    width: 280px;
    object-fit: cover;
  }

  .recommend-no-history {
    font-family: DiDiSans-Pro-Bold;
    font-size: 40px;
    color: #000;
    letter-spacing: 0;
    text-align: center;
    line-height: 48px;
  }
}
</style>